/**
 * Initialise variant selection for all custom product cards.
 * When a variant <li> is clicked:
 *  - marks it as active
 *  - updates the hidden "id" input inside the nearest product-form-component
 *  - updates the price <span> inside the ATC button
 */
window.initCustomProductCardVariants = (element) => {
  const li = element;
  if (!li) return;

  const card = li.closest('.block__custom-product-card'); 
  if (!card) return;

  const variantId = li.dataset.variantId;
  const variantPrice = li.dataset.variantPrice;

  // 1. Update active state on list items
  const variantList = li.closest('ul');
  if (variantList) {
    variantList.querySelectorAll('li').forEach((item) => item.classList.remove('active'));
    li.classList.add('active');
  }

  // 2. Update the hidden variant ID input
  const variantInput = card.querySelector('input[name="id"]');
  if (variantInput && variantId) {
    variantInput.value = variantId;
  }

  // 3. Update the price in the ATC button
  const priceSpan = card.querySelector('.block__custom-product-card-button .price');
  if (priceSpan && variantPrice) {
    priceSpan.textContent = variantPrice;
  }

  // 4. Hide error message if exists
  const errorMsg = card.querySelector('.variant-error-message');
  if (errorMsg) {
    errorMsg.style.display = 'none';
  }
};

document.addEventListener('click', function(event) {
  // 1. Click on standalone add-to-cart button
  const standaloneBtn = event.target.closest('.standalone-add-to-cart');
  if (standaloneBtn) {
    const contentParent = standaloneBtn.closest('.block__custom-product-card-content');
    if (contentParent) {
      contentParent.classList.add('is-active');
    }
    return;
  }

  // 2. Click on the actual add-to-cart button (ref="addToCartButton")
  const mainAddToCartBtn = event.target.closest('[ref="addToCartButton"], button[name="add"]');
  if (mainAddToCartBtn) {
    const contentParent = mainAddToCartBtn.closest('.block__custom-product-card-content');
    if (contentParent) {
      contentParent.classList.remove('is-active');
    }
  }

  // 3. Click outside of the active .block__custom-product-card-content
  const clickedContent = event.target.closest('.block__custom-product-card-content');
  const activeContents = document.querySelectorAll('.block__custom-product-card-content.is-active');
  
  activeContents.forEach((activeEl) => {
    // Remove the class if clicked outside or clicked on a DIFFERENT product card
    if (activeEl !== clickedContent) {
      activeEl.classList.remove('is-active');
    }
  });
});
 